// ============================================
// @ind-money/socket-manager
// Unified WebSocket and NATS connection management
// ============================================

// Provider
export {
  SocketManagerProvider,
  type SocketManagerProviderProps,
} from './providers';
export {
  SocketManagerContext,
  useSocketManagerContext,
} from './providers/context';

// Hooks
export {
  useLivePrice,
  useLivePriceMultiple,
  useWebSocket,
  usePricesConnection,
  useTradesConnection,
  useUSPricesConnection,
  useNats,
  useNatsStatus,
  useLiveDepth,
  type UseLivePriceOptions,
  type UseLivePriceMultipleOptions,
  type UseLiveDepthOptions,
  type IndianStocksOptions,
  type USStocksOptions,
  type IndianStocksMultipleOptions,
  type USStocksMultipleOptions,
} from './hooks';

// Managers (for advanced usage)
export {
  WebSocketManager,
  PricesWebSocketManager,
  TradesWebSocketManager,
  USPricesWebSocketManager,
  NatsManager,
  NATS_EVENT_NAMES,
} from './library';

// Types
export type {
  // Config types
  SocketManagerProviderConfig,
  WebSocketManagerConfig,
  PricesWebSocketManagerConfig,
  TradesWebSocketManagerConfig,
  NatsManagerConfig,
  LoggerConfig,
  AnalyticsConfig,
  LogLevel,

  // Data types
  LivePriceData,
  PriceData,
  TradeData,
  DataSource,

  // Callback types
  PriceCallback,
  TradesCallback,
  NatsMessageCallback,
  ConnectionCallback,

  // Context types
  SocketManagerContextValue,
} from './types';

// US Prices types from library (re-export)
export type {
  USPriceCallback,
  USPricesWebSocketManagerConfig,
} from './library';

// Enum exports (values, not just types)
export { WebSocketClientType, TradeEventTypes, TradeEventMode } from './types';
